export default __webpack_public_path__ + "static/media/AlumniVentures.76b21577.svg";